import { Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import useGetRealTime from 'hooks/useGetRealTime/useGetRealTime'
import useCalTotalHour from 'hooks/useCalTotalHour/useCalTotalHour'
import { TimeClockInfoContract } from 'models'
import { countingTotalHourLogic, TotalHourType } from './timeClockMenuLogic'
import { Variant } from '@mui/material/styles/createTypography'
import { useMobileOrientation } from 'react-device-detect'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

const PrintRealTime = ({
    align,
    format = '',
    variant = 'h3',
}: {
    align: any
    format?: string
    variant?: Variant
}) => {
    const [realTime] = useGetRealTime()

    return (
        <Typography variant={variant} align={align} color="white">
            {dayjs(realTime).format(format)}
        </Typography>
    )
}

const PrintTotalHours = ({
    text,
    defaultTime,
    isCounting = true,
    variant = 'subtitle1',
}: {
    text: string
    defaultTime: string
    isCounting?: boolean
    variant?: any
}) => {
    const [time] = useCalTotalHour({
        defaultTime,
        isCounting,
    })

    return (
        <>
            <Grid item xs={7}>
                <Typography color="white" align="left" variant={variant}>
                    {text}
                </Typography>
            </Grid>
            <Grid item xs={5}>
                <Typography color="white" align="right" variant={variant}>
                    {time?.format('HH:mm')}
                </Typography>
            </Grid>
        </>
    )
}

const ShowTimeClockText = ({
    timeClock,
    loading = false,
}: {
    timeClock: TimeClockInfoContract | undefined
    loading?: boolean
}) => {
    const { isPortrait } = useMobileOrientation()
    const { isMobile } = useScreenSize()

    return (
        <Grid container alignItems="center" justifyContent="center">
            {loading ? (
                'loading...'
            ) : (
                <>
                    <Grid
                        item
                        container
                        xs={12}
                        justifyContent={'space-between'}
                        alignItems="flex-end"
                        mb={1}
                    >
                        <Grid item xs={isPortrait ? 4 : 12}>
                            <PrintRealTime
                                align={isPortrait ? 'left' : 'center'}
                                variant={isMobile ? 'h5' : 'h3'}
                                format="hh:mm A"
                            />
                        </Grid>
                        <Grid item xs={isPortrait ? 8 : 12}>
                            <PrintRealTime
                                align={isPortrait ? 'right' : 'center'}
                                variant={isMobile ? 'subtitle2' : 'subtitle1'}
                                format="dddd, MMMM D, YYYY"
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={7}>
                        <Typography
                            align="left"
                            color="white"
                            variant={isMobile ? 'subtitle2' : 'subtitle1'}
                        >
                            Start Time Today:
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography
                            align="right"
                            color="white"
                            variant={isMobile ? 'subtitle2' : 'subtitle1'}
                        >
                            {timeClock && timeClock.shiftStartTime
                                ? dayjs(timeClock.shiftStartTime).format(
                                      'hh:mm A',
                                  )
                                : '-'}
                        </Typography>
                    </Grid>
                    {timeClock && timeClock.latestStatus && (
                        <>
                            {timeClock.useBreak && (
                                <PrintTotalHours
                                    text="Total Time Break:"
                                    defaultTime={timeClock.totalBreakTime || ''}
                                    isCounting={countingTotalHourLogic(
                                        TotalHourType.BREAK,
                                        timeClock.latestStatus,
                                    )}
                                    variant={
                                        isMobile ? 'subtitle2' : 'subtitle1'
                                    }
                                />
                            )}
                            {timeClock.useMealBreak && (
                                <PrintTotalHours
                                    text="Total Time Meal Break:"
                                    defaultTime={
                                        timeClock.totalMealBreakTime || ''
                                    }
                                    isCounting={countingTotalHourLogic(
                                        TotalHourType.MEAL_BREAK,
                                        timeClock.latestStatus,
                                    )}
                                    variant={
                                        isMobile ? 'subtitle2' : 'subtitle1'
                                    }
                                />
                            )}
                            <PrintTotalHours
                                text="Total Time Today:"
                                defaultTime={timeClock.totalTimeWorkTime || ''}
                                isCounting={countingTotalHourLogic(
                                    TotalHourType.WORK,
                                    timeClock.latestStatus,
                                )}
                                variant={isMobile ? 'subtitle2' : 'subtitle1'}
                            />
                        </>
                    )}
                </>
            )}
        </Grid>
    )
}

export default ShowTimeClockText
